"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NowPlaying = NowPlaying;
const React = __importStar(require("react"));
const react_jss_1 = require("react-jss");
const react_redux_1 = require("react-redux");
const players_1 = require("~/store/game/players");
const models_1 = require("@creature-chess/models");
const useStyles = (0, react_jss_1.createUseStyles)({
    nowPlaying: {
        position: "absolute",
        top: 0,
        color: "#ffffff",
        width: "100%",
        textAlign: "center",
        padding: "4px",
        boxSizing: "border-box",
        background: "rgba(0, 0, 0, 0.8)",
        zIndex: 400,
    },
});
function NowPlaying() {
    const styles = useStyles();
    const phase = (0, react_redux_1.useSelector)((state) => state.game.roundInfo.phase);
    const opponent = (0, players_1.useOpponentPlayer)();
    if (phase !== models_1.GamePhase.READY && phase !== models_1.GamePhase.PLAYING) {
        return null;
    }
    if (!opponent) {
        return null;
    }
    return React.createElement("div", { className: styles.nowPlaying },
        "Now Playing: ",
        opponent.name);
}
